/**
 * SegmentedButton density / geometry — the shape axis.
 * Appearance ink lives in SegmentedButton.color.ts.
 */

import type { SegmentedButtonRounded, SegmentedButtonSize } from './SegmentedButton.types';

export const SEGMENTED_TRACK_PAD: Record<SegmentedButtonSize, string> = {
  sm: 'p-0.5',
  md: 'p-1',
  lg: 'p-1',
};

export const SEGMENTED_TRACK_GAP: Record<SegmentedButtonSize, string> = {
  sm: 'gap-0.5',
  md: 'gap-0.5',
  lg: 'gap-1',
};

export const SEGMENTED_TYPE: Record<SegmentedButtonSize, string> = {
  sm: 'text-xs font-semibold font-body leading-none gap-1.5',
  md: 'text-sm font-semibold font-body leading-none gap-2',
  lg: 'text-sm font-semibold font-body leading-none gap-2',
};

/** Hug-content segment padding. */
export const SEGMENTED_SEGMENT: Record<SegmentedButtonSize, string> = {
  sm: 'h-7 px-2.5',
  md: 'h-8 px-3',
  lg: 'h-9 px-3.5',
};

/** Equal-width plan strips use a bit more vertical room at md. */
export const SEGMENTED_SEGMENT_EQUAL: Record<SegmentedButtonSize, string> = {
  sm: 'h-8 px-2.5',
  md: 'h-9 px-3',
  lg: 'h-10 px-3.5',
};

export const SEGMENTED_ICON: Record<SegmentedButtonSize, string> = {
  sm: '[&_svg]:h-3.5 [&_svg]:w-3.5',
  md: '[&_svg]:h-4 [&_svg]:w-4',
  lg: '[&_svg]:h-4 [&_svg]:w-4',
};

export const SEGMENTED_ROUNDED_TRACK: Record<SegmentedButtonRounded, string> = {
  md: 'rounded-md',
  lg: 'rounded-lg',
  full: 'rounded-full',
};

export const SEGMENTED_ROUNDED_SEGMENT: Record<SegmentedButtonRounded, string> = {
  md: 'rounded',
  lg: 'rounded-md',
  full: 'rounded-full',
};
